"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrectionConfirmationModal = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Text_1 = require("@amzn/atoz-web/Text");
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const luxon_1 = require("luxon");
const PunchCorrectionConfirmationModal = ({ closeModal, correctionDateTimeISO, acceptPunchCorrection }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const correctionDateTime = luxon_1.DateTime.fromISO(correctionDateTimeISO);
    const buttons = [
        react_1.default.createElement(Button_1.Button, { key: "PunchCorrectionConfirmationModalSubmitButton", variant: Button_1.ButtonVariant.Primary, onClick: acceptPunchCorrection, dataTestId: "punch-correction-modal-continue" }, t('time_and_attendance_PunchCorrectionConfirmationModal_Confirm'))
    ];
    return (react_1.default.createElement(Modal_1.ModalContent, { onCloseButtonClick: closeModal, dataTestId: "punch-correction-modal", titleText: t('time_and_attendance_PunchCorrectionConfirmationModal_Title'), buttons: buttons },
        react_1.default.createElement(Text_1.Text, null, t('time_and_attendance_PunchCorrectionConfirmationModal_Content', {
            correctionDate: correctionDateTime.toLocaleString({
                month: 'long',
                day: 'numeric'
            }),
            correctionTime: correctionDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        }))));
};
exports.PunchCorrectionConfirmationModal = PunchCorrectionConfirmationModal;
